import React from 'react'

export default function BorderRadiusAll({ color = '#7246B1', style = {} }) {
    return (
        <svg
            className='icons-icon'
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <rect x='4' y='4' width='12' height='12' rx='3' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
